import {
  useInvestmentInstrumentList as useInvestmentInstrumentListQuery,
  useInvestmentInstrumentGet as useInvestmentInstrumentGetQuery,
  type InstrumentSurfaceDto,
} from '../../../api/generated/client';
import { ROUTE_IDS, OPERATION_IDS } from '@finance/contracts';
import type { ListHookResult, GetHookResult, ResourceHookBinding } from '../../resource-hook-registry.js';
import { selectApiData, type ApiSuccessEnvelope } from '../../../api/select-api-data.js';

function selectInstrumentListRows(response: unknown): InstrumentSurfaceDto[] {
  const envelope = selectApiData(
    response as ApiSuccessEnvelope<{ data: InstrumentSurfaceDto[]; meta: unknown }>
  );
  return envelope?.data ?? [];
}

function selectInstrumentDetail(response: unknown): InstrumentSurfaceDto {
  const envelope = selectApiData(
    response as ApiSuccessEnvelope<{ data: InstrumentSurfaceDto; meta: unknown }>
  );
  return envelope.data;
}

export function useInstrumentList(): ListHookResult<InstrumentSurfaceDto[]> {
  return useInvestmentInstrumentListQuery({ query: { select: selectInstrumentListRows } });
}

export function useInstrumentGet(id: string): GetHookResult<InstrumentSurfaceDto> {
  return useInvestmentInstrumentGetQuery(id, { query: { select: selectInstrumentDetail } });
}

export const INSTRUMENTS_HOOKS: ResourceHookBinding<InstrumentSurfaceDto[], InstrumentSurfaceDto> = {
  useList: useInstrumentList,
  selectList: selectInstrumentListRows,
  useGet: useInstrumentGet,
  selectDetail: selectInstrumentDetail,
  rowIdExtractor: (row) => (typeof row.symbol === 'string' ? row.symbol : undefined),
  rowIdField: 'symbol',
  routeParameterName: 'symbol',
  paramName: 'symbol',
  listRouteId: ROUTE_IDS.DATA_INSTRUMENTS,
  detailRouteId: ROUTE_IDS.DATA_INSTRUMENT_DETAIL,
  readOperationId: OPERATION_IDS.INSTRUMENT_GET,
  detailDescriptorId: 'detail.instruments',
};
